/* eslint-disable @stylistic/brace-style */
import { PlayerService } from "./PlayerService";

export type UseOwnNameResponse = { success: boolean; playerName?: string; error?: string };

export class UseOwnNameService {
    private readonly _playerService: PlayerService = new PlayerService();

    public async setPlayerName(playerName: string): Promise<UseOwnNameResponse> {
        try {
            const response: Response = await fetch(`${VITE_API_URL}use-own-name`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-PlayerSessionId": this._playerService.getPlayerSessionId(), // Als je een sessie-ID nodig hebt
                },
                body: JSON.stringify({ playerName }),
            });

            return await (response.json() as Promise<UseOwnNameResponse>);
        } catch (error) {
            console.error("Error setting player name:", error);
            return { success: false, error: "An error occurred while setting the player name." };
        }
    }
}
